import { useEffect } from 'react';

import { fabric } from 'fabric';

import { BackspaceKey, DeleteKey } from '~/keyboard';

import { IUseFabric } from './types';

export const useDeleteSelection = (props: IUseFabric) => {
  const { ref, context } = props;
  const { annotationEnabled } = context;

  useEffect(() => {
    const canvas = ref.current;
    let list: fabric.Object[];
    let isEditing = false;
    const handleEditing = () => {
      isEditing = true;
    }
    const handleEditingExited = () => {
      // time out is required to avoid adding another text when clicking outside of text to stop editing
      setTimeout(() => {
        isEditing = false;
      }, 100);
    }
    const handleSelection = () => {
      list = canvas.getActiveObjects()
    }
    const handleDelete = (e: KeyboardEvent) => {
      if (!isEditing && list?.length > 0 && [BackspaceKey, DeleteKey].includes(e.key)) {
        canvas
          .discardActiveObject()
          .remove(...list)
          .renderAll();
      }
    }

    if (annotationEnabled) {
      canvas.on('selection:created', handleSelection);
      canvas.on('selection:updated', handleSelection);
      canvas.on('text:editing:entered', handleEditing);
      canvas.on('text:editing:exited', handleEditingExited);
      document.addEventListener('keydown', handleDelete);
      return () => {
        canvas.off('selection:created', handleSelection);
        canvas.off('selection:updated', handleSelection);
        canvas.off('text:editing:entered', handleEditing);
        canvas.off('text:editing:exited', handleEditingExited);
        document.removeEventListener('keydown', handleDelete);
      }
    }
  }, [annotationEnabled, ref]);
}
